import { ReactComponent as CalendarAltRegular } from '../../assets/svg/calendar-alt-regular.svg';

export default CalendarAltRegular;
